module.exports = __webpack_public_path__ + "img/portrait.5dcf3b2a.jpg";